<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('reportClassAttendance.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('reportClassAttendance.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('reportClassAttendance.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportClassAttendance.acYear')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.ac_year_id"
                        :options="ac_year_list"
                        @change="acYearChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_year_id')">
                        {{ errors.first('ac_year_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportClassAttendance.acTerm')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.ac_term_id"
                        :options="ac_terms"
                        :show-search="true"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        @change="acTermChange"
                        :disabled="!model.ac_year_id"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportClassAttendance.subProgram')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.acps_id"
                        :options="sub_programs"
                        :show-search="true"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportClassAttendance.date')
                      }}</label>
                      <a-range-picker
                        format="DD-MM-YYYY"
                        v-model="rangeDate"
                        :disabled-date="disabledDate"
                        @change="dateRangeChange"
                      >
                        <template slot="renderExtraFooter"></template>
                      </a-range-picker>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportClassAttendance.classOperation')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model="model.class_id"
                        :options="class_options"
                        :show-search="true"
                        :placeholder="$t('all')"
                        :limit="1"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 text-right">
                      <ts-button
                        class="btn-block"
                        outline
                        color="success"
                        @click.prevent="exportExcel"
                        :waiting="exporting"
                        >{{ $t('excel') }}</ts-button
                      >
                    </div>
                    <div class="col-md-6 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('reportClassAttendance.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
import moment from 'moment'
import { debounce } from 'lodash'

export default {
  name: 'reportClassAttendance',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: '',
      errors: new Errors(),
      sub_programs: [],
      ac_terms: [],
      ac_year_list: [],
      class_options: [],
      headers: [],
      columnLists: [],
      rangeDate: [moment().startOf('month'), moment().endOf('month')],
      rangeTermStart: null,
      rangeTermEnd: null,

      model: {
        acps_id: null,
        ac_term_id: null,
        ac_year_id: null,
        class_id: null
      }
    }
  },
  created() {
    this.fetchData()
    this.getHeader()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'classAttendance',
      'getSubProgram',
      'getTerm',
      'getYear',
      'getClass'
    ]),
    moment,
    async fetchData() {
      this.loading = true
      await this.getYear()
        .then(response => {
          this.ac_year_list = response.data.map(el => ({
            value: el.ac_year_id,
            label:
              el.ac_year +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.getTerm()
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) '),
            term_start: el.term_start,
            term_stop: el.term_stop
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getHeader() {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('reportAcademic/getHeader', this.model)
        .then(response => {
          this.headers = response['columnHeaders']
          this.columnLists = response['columnLists']
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    // onSubChange(acps_id) {
    // 	this.model.ac_term_id = null
    // 	this.model.class_id = []
    // 	this.loading = true
    // 	this.getTerm({
    // 		filter: {
    // 			acps_id: acps_id,
    // 			ac_year_id: this.model.ac_year_id,
    // 		},
    // 	})
    // 		.then(response => {
    // 			this.ac_terms = response.data.map(el => ({
    // 				value: el.ac_term_id,
    // 				label:
    // 					el.term_name +
    // 					(el.ac_status_id == 1
    // 						? ' ( Current ) '
    // 						: el.ac_status_id == 2
    // 							? ' ( History ) '
    // 							: ' ( Next ) ')
    // 			}))
    // 		})
    // 		.catch(error => {
    // 			this.$toasted.error(error.message)
    // 		})
    // 		.finally(() => {
    // 			this.loading = false
    // 		})
    // },
    acYearChange() {
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = []
    },
    // acTermChange(ac_term_id) {
    // 	this.loading = true
    // 	this.getClass({
    // 		filter: {
    // 			ac_term_id: ac_term_id,
    // 		},
    // 	})
    // 		.then(response => {
    // 			this.class_options = response.data.map(el => ({
    // 				value: el.class_id,
    // 				label:
    // 					el.class_name +
    // 					' | ' +
    // 					el.teacher.full_name_en +
    // 					' | ' +
    // 					el.academic_study_time.study_time
    // 			}))
    // 		})
    // 		.catch(error => {
    // 			this.$toasted.error(error.message)
    // 		})
    // 		.finally(() => {
    // 			this.loading = false
    // 		})
    // },
    acTermChange(ac_term_id) {
      this.loading = true
      this.model.acps_id = null
      this.model.class_id = []

      const selectedTerm = this.ac_terms.find(t => t.value === ac_term_id)
      if (selectedTerm) {
        const termStart = moment(selectedTerm.term_start, 'DD-MM-YYYY')
        const termEnd = moment(selectedTerm.term_stop, 'DD-MM-YYYY')

        console.log('term_start:', selectedTerm.term_start)
console.log('term_stop:', selectedTerm.term_stop)
console.log('termStart valid:', termStart.isValid())
console.log('termEnd valid:', termEnd.isValid())

        // Determine start date safely
        let start
        const today = moment()
        if (today.isBefore(termStart)) {
          start = termStart.clone()
        } else if (today.isAfter(termEnd)) {
          // Last 7 days of term
          start = termEnd.clone().subtract(6, 'days')
          if (start.isBefore(termStart)) {
            start = termStart.clone() // clamp if term < 7 days
          }
        } else {
          start = today.clone()
        }

        // Determine end date: max 7 days, but not after termEnd
        let end = moment.min(start.clone().add(6, 'days'), termEnd)

        // Assign to component state
        this.rangeDate = [start, end]
        this.rangeTermStart = termStart
        this.rangeTermEnd = termEnd

        this.$store.commit(
          'reportAcademic/SET_START_DATE',
          start.format('DD-MM-YYYY')
        )
        this.$store.commit(
          'reportAcademic/SET_END_DATE',
          end.format('DD-MM-YYYY')
        )
      }

      // Fetch sub-programs
      this.getSubProgram({ filter: { ac_term_id } })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => this.$toasted.error(error.message))
        .finally(() => {
          this.loading = false
        })

      // Fetch classes
      this.getClass({ filter: { ac_term_id } })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              ' | ' +
              el.teacher.full_name_en +
              ' | ' +
              el.academic_study_time.study_time
          }))
        })
        .catch(error => this.$toasted.error(error.message))
        .finally(() => {
          this.loading = false
        })
    },

    disabledDate(current) {
      if (!this.rangeTermStart || !this.rangeTermEnd) return false
      // Disable dates before term_start or after term_stop
      return (
        current.isBefore(this.rangeTermStart, 'day') ||
        current.isAfter(this.rangeTermEnd, 'day')
      )
    },

    dateRangeChange(dateRange) {
      if (!dateRange || dateRange.length === 0) return

      let start = dateRange[0]
      let end = dateRange[1]

      const maxDays = 35
      const diff = end.diff(start, 'days')

      // If range is longer than 35 days → adjust start date forward
      if (diff > maxDays) {
        start = end.clone().subtract(maxDays, 'days')
      }

      // Keep range within term boundaries
      if (start.isBefore(this.rangeTermStart)) {
        start = this.rangeTermStart.clone()
        end = start.clone().add(maxDays, 'days')
        if (end.isAfter(this.rangeTermEnd)) {
          end = this.rangeTermEnd.clone()
        }
      }

      this.rangeDate = [start, end]

      this.$store.commit(
        'reportAcademic/SET_START_DATE',
        start.format('DD-MM-YYYY')
      )
      this.$store.commit(
        'reportAcademic/SET_END_DATE',
        end.format('DD-MM-YYYY')
      )
    },

    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.classAttendance(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('reportAcademic/classAttendanceExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    model: debounce(function(value) {
      this.getHeader()
    }, 500)
  }
}
</script>
